import React from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';

const EeClassesHeader = (): JSX.Element => {
  return (
    <PageHeader
      title="Employee Classes"
      subtitle="Classes group employees based on how the business has designed their benefit program"
      subtitleMaxWidth="50rem"
    />
  );
};

export default EeClassesHeader;
